<template>
    <AuthenticatedLayout>

        <Toast position="top-center" />

        <div class="text-4xl mt-4 mb-4 flex flex-row">
            <div>Preview JmcBot for {{pair.symbol}} {{timeframe}}</div>
            <div class="ml-2">
                <a class="text-gray-400" :href="tradingViewUrl" target="_blank"><i class="pi pi-external-link" style="font-size: 1.5rem"></i></a>
            </div>
        </div>

        <div class="mb-4">
            <Button class="p-button-success mr-3" label="Сохранить настройки" icon="pi pi-save" @click="saveSettings" />
<!--            <Button class="p-button-primary mr-3" label="Загрузить текущие рабочие настройки"  @click="loadSettings" />-->
            <Button class="p-button-primary mr-6" label="Загрузить настройки по умолчанию"  @click="loadDefaultSettings" />
            <Link :href="'/jmc/'+pair.id" class="no-underline"><Button class="p-button-primary" label="Вернуться в рабочий бот" /></Link>
        </div>

        <div class="flex flex-row mb-4">

            <div class="w-32rem mr-4 flex flex-col">
                <Card class="">
                    <template #title>Bot</template>
                    <template #content>

                        <JmcBotSettings
                            v-model="form.botSettings"
                        />

                    </template>
                </Card>
            </div>

            <div>
                <Card class="">
                    <template #title>Settings history</template>
                    <template #content>

                        <div v-for="history in settingsHistory" class="mb-2 p-2">
                            {{short_timezoned(history.created_at)}}: ({{history.count_closed_deals}}/{{history.count_open_deals}} ${{round(history.potential_profit, 2)}}) sharp:{{history.sharpe_ratio}}
                            <span class="ml-2 cursor-pointer underline" @click="loadHistory(history)">load</span>
                        </div>

                    </template>
                </Card>
            </div>


        </div>

        <div class="flex flex-row mb-4">
            <Card class="w-full">
                <template #content>
                    <div class="flex flex-row align-items-end">
                        <div class="mr-4">
                            <div>Начало периода работы UTC</div>
<!--                            <Calendar v-model="form.dateStart" dateFormat="yy-mm-dd" :showTime="true" :showSeconds="false" />-->
                            <InputText type="text" v-model="form.dateStart" />
                        </div>
                        <div class="mr-4">
                            <div>Конец периода работы UTC</div>
<!--                            <Calendar v-model="form.dateEnd" dateFormat="yy-mm-dd" :showTime="true" :showSeconds="false" />-->
                            <InputText type="text" v-model="form.dateEnd" />
                        </div>
                        <div>
                            <SpinnerWrapper :loading="isLaunch">
                                <Button label="Протестировать период (Enter)" @click="handleLaunch"></Button>
                            </SpinnerWrapper>
                        </div>
                    </div>
                </template>
                <template #footer v-if="errorLaunch">
                    <div class="text-red-500">{{errorLaunch}}</div>
                </template>
            </Card>
        </div>

        <div class="flex flex-row mb-4" v-if="showResults">

            <Card class="w-full">
                <template #content>

<!--                    <DataTable :value="rowResults" >-->
<!--                        <Column field="name" header="Результаты" />-->
<!--                        <Column field="sharpeRatio" header="Sharpe Ratio" />-->
<!--                        <Column field="profit" header="Profit" />-->
<!--                        <Column field="maxDrawdown" header="Max Drawdown" />-->
<!--                        <Column field="winRate" header="Win Rate" />-->
<!--                    </DataTable>-->

                    <div class="flex flex-row">
                        <div class="mr-4">
                            <ReplayDataArea :replayData="replayData" title="Текущие результаты"/>
                        </div>
                        <div class="mr-4" v-if="bestResults">
                            <ReplayDataArea :replayData="bestResults" title="Лучшие результаты" :allow-load="true" :load-function="loadResults"/>
                        </div>
                        <div class="mr-4" v-for="prevData in prevResults">
                            <ReplayDataArea :replayData="prevData" title="Прошлые результаты" :allow-load="true" :load-function="loadResults"/>
                        </div>
                    </div>

                    <div v-if="showCandles" class="mt-4">

<!--                        <SelectButton class="mb-2" v-model="showSelector" :options="[{name:'Прибыль и просадка', value: 'profit'}, {name:'График свечей', value: 'candles'}]" optionLabel="name" optionValue="value"/>-->

                        <div v-show="showSelector === 'profit'">
                            <CumulativeProfit
                                :replayData="replayData"
                                :height="400"
                                :width="maxWidth"
                            />
                        </div>
                        <div v-show="showSelector === 'candles'">

                        </div>

                        <CandlesDealsJmc
                            :candles="candles"
                            :deals="deals"
                            :indicators="indicators"
                            :pair="pair.symbol + ' ' + replayData.timeframe"
                            :width="maxWidth"
                            :height="500"
                            :timezone="0"
                            :zeroPrice="currentPrice"
                        />

                    </div>

                    <div class="flex flex-row w-full mt-4">
                        <Card class="flex-1 mr-4">
                            <template #title>Сделки</template>
                            <template #content>
                                <ClosedDealsTable :deals="closedDeals" :currentPrice="currentPrice" :currentDate="dateEnd"/>
                            </template>
                        </Card>

                        <Card class="flex-1">
                            <template #title>Логи</template>
                            <template #content>
                                <LogsTable :logs="logs" :pagination="true"/>
                            </template>
                        </Card>
                    </div>

                </template>
            </Card>
        </div>

    </AuthenticatedLayout>
</template>
<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import Toast from "primevue/toast";
import HllBotSettings from "@/Settings/HllBotSettings.vue";
import Card from "primevue/card";
import Calendar from "primevue/calendar";
import Button from "primevue/button";
import InputText from 'primevue/inputtext';
import SpinnerWrapper from "@/Components/SpinnerWrapper.vue";
import CandlesWithDealsAndIndicators from "@/Charts/CandlesDealsGrid.vue";
import CandlesWithDeals from "@/Charts/Candles.vue";
import helperMethods from "@/helpers";
import LogsTable from "@/Tables/LogsTable.vue";
import OpenDealsTable from "@/Tables/OpenDealsTable.vue";
import ClosedDealsTable from "@/Tables/ClosedDealsTable.vue";
import CandlesDealsHll from "@/Charts/CandlesDealsHll.vue";
import {Link} from "@inertiajs/vue2";
import MiddletrendSettings from "@/Settings/MiddletrendSettings.vue";
import CandlesDealsJmc from "@/Charts/CandlesDealsJmc.vue";
import CumulativeProfit from "@/Charts/CumulativeProfit.vue";
import ReplayDataArea from "@/Pages/Preview/ReplayDataArea.vue";
import JmcBotSettings from "@/Settings/JmcBotSettings.vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import SelectButton from "primevue/selectbutton";
import { format } from "date-fns";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
    props: {
        userBotId: Number,
        pair: Object,
        tradingViewUrl: String,
        bot_settings: Object,
        dateStart: String,
        dateEnd: String,
        settingsHistory: Array,
        timeframe: String

    },
    components:{
        JmcBotSettings,
        ReplayDataArea,
        CumulativeProfit,
        CandlesDealsJmc,
        Link,
        ClosedDealsTable,
        OpenDealsTable,
        LogsTable,
        SpinnerWrapper,
        AuthenticatedLayout,
        Toast, Card, Calendar, Button, InputText,
        TabView, TabPanel, SelectButton, DataTable, Column
    },
    data(){
        return {
            form:{
                botSettings: {},
                dateStart: null,
                dateEnd: null,
            },

            isLaunch: false,
            showResults: false,
            showCandles: true,
            showSelector: 'profit',

            candles: null,
            deals: null,
            indicators: null,
            logs: null,
            currentPrice: null,
            replayData: null,

            prevResults: [],
            bestResults: null,

            errorLaunch: null
        }
    },
    created() {
        window.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                this.handleLaunch();
            }
        });
    },
    mounted() {
        this.form.botSettings = this.bot_settings;
        this.form.dateStart = this.dateStart;
        this.form.dateEnd = this.dateEnd;
    },
    computed:{
        closedDeals(){
            if(this.deals === null){
                return [];
            }
            return this.deals.filter(deal => deal.completed_at !== null);
        },
        maxWidth(){
            return window.innerWidth - 150;
        },
        rowResults(){
            let array = [];
            if(this.replayData !== null){
                this.replayData.name = "Текущие результаты";
                array.push(this.replayData);
            }
            if(this.prevResults !== null){
                this.prevResults.forEach((item, index) => {
                    item.name = "Прошлые результаты " + index;
                    array.push(item);
                });
            }
            if(this.bestResults !== null){
                this.bestResults.name = "Лучшие результаты";
                array.push(this.bestResults);
            }
            return array;
        }
    },
    methods:{
        handleLaunch(){
            this.isLaunch = true;
            // this.candles = [];
            this.errorLaunch = null;
            let prevResultTemp = null;
            if(this.replayData !== null){
                prevResultTemp = this.replayData;
            }

            axios.post('/preview/jmc/launch/', {
                id: this.userBotId,
                form: this.form,
            }).then(response => {

                if(prevResultTemp !== null) {
                    this.prevResults.unshift(prevResultTemp);
                    this.prevResults = this.prevResults.slice(0, 2);
                }

                this.candles = response.data.replayData.candles;
                this.deals = response.data.replayData.deals;
                this.indicators = response.data.replayData.indicators;
                this.logs = response.data.replayData.logs;
                this.replayData = response.data.replayData;
                this.currentPrice = response.data.currentPrice;

                if(this.bestResults === null || this.bestResults.sharpeRatio < this.replayData.sharpeRatio) {
                    this.bestResults = this.replayData;
                }

                this.isLaunch = false;
                this.showResults = true;

            }).catch(error => {
                this.isLaunch = false;
                // this.errorLaunch = error+" | ";
                if (error.response) {
                    this.errorLaunch = error.response.data.message;
                }

            });
        },
        saveSettings(){
            axios.post('/preview/save_settings/', {
                userBotId: this.userBotId,
                botSettings: this.form.botSettings,
            }).then(response => {
                if(response.data.status === "success"){
                    this.$toast.add({severity:'success', summary: 'Success', detail: 'Настройки записаны в работающего бота', life: 3000});
                }
            })
        },
        loadSettings(){
            axios.post('/preview/load_settings/', {
                userBotId: this.userBotId,
            }).then(response => {
                if(response.data.status === "success"){
                    this.form.botSettings = response.data.bot_settings;
                }

            })
        },
        loadDefaultSettings(){
            axios.post('/preview/load_default_settings/', {
                userBotId: this.userBotId,
            }).then(response => {
                this.form.botSettings = response.data.bot_settings;
                this.$toast.add({severity:'success', summary: 'Success', detail: 'Загружены настройки по умолчанию', life: 3000});
            })


        },
        ...helperMethods,
        loadResults(replayData){
            this.candles = replayData.candles;
            this.deals = replayData.deals;
            this.indicators = replayData.indicators;
            this.logs = replayData.logs;
            this.currentPrice = replayData.currentPrice;
            this.form.botSettings = replayData.botSettings;
            this.replayData = replayData;
        },
        loadHistory(history){
            this.form.botSettings.jmaLength = history.after.jmaLength;
            this.form.botSettings.jmaPhase = history.after.jmaPhase;
            this.form.botSettings.jmaPower   = history.after.jmaPower;
            this.form.botSettings.atrLength = history.after.atrLength;
            this.form.botSettings.atrMultBuy = history.after.atrMultBuy;
            this.form.botSettings.atrMultSell = history.after.atrMultSell;
            this.form.botSettings.minWidthPercentile = history.after.minWidthPercentile;
            this.form.botSettings.widthPercentileLength = history.after.widthPercentileLength;
            this.form.botSettings.maxBarsOutsideBand = history.after.maxBarsOutsideBand;
            this.form.botSettings.periodOutsideBand = history.after.periodOutsideBand;
            this.form.botSettings.fastLength = history.after.fastLength;
            this.form.botSettings.fastPhase = history.after.fastPhase;
            this.form.botSettings.fastPower = history.after.fastPower;

            this.candles = [];
            this.deals = [];
            this.indicators = [];
            this.logs = [];
            this.currentPrice = null;
        }
    }

}
</script>
